import { guideSteps } from '@/mocks/site';

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase">
            <i className="ri-guide-line"></i> HOW TO USE
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">下载与播放指南</h2>
          <p className="mt-2 text-sm text-foreground-600">
            从检索影片到本地播放，只需四个步骤。按下面的流程操作，可以更快找到合适的版本并顺利观影。
          </p>
        </div>

        <ol className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guideSteps.map((s, i) => (
            <li key={s.step} className="relative p-5 rounded-lg border border-background-200 bg-background-100">
              <span className="font-heading text-4xl font-bold text-primary-200">{s.step}</span>
              <span className="absolute top-5 right-5 w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className={`${s.icon} text-lg`}></i>
              </span>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">{s.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{s.desc}</p>
              {i < guideSteps.length - 1 && (
                <i className="hidden lg:flex ri-arrow-right-line absolute top-1/2 -right-4 text-background-400 -translate-y-1/2 z-10"></i>
              )}
            </li>
          ))}
        </ol>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 rounded-lg bg-secondary-50 border border-secondary-200 flex items-start gap-3">
            <i className="ri-hard-drive-3-line text-secondary-600 text-lg mt-0.5"></i>
            <p className="text-xs leading-relaxed text-secondary-900">
              <span className="font-semibold">预留空间：</span>4K 原盘单片常在 15GB 以上，下载前请确认磁盘剩余容量。
            </p>
          </div>
          <div className="p-4 rounded-lg bg-accent-50 border border-accent-200 flex items-start gap-3">
            <i className="ri-download-2-line text-accent-700 text-lg mt-0.5"></i>
            <p className="text-xs leading-relaxed text-accent-900">
              <span className="font-semibold">离线加速：</span>冷门资源在线时间较短，可借助离线下载提高成功率。
            </p>
          </div>
          <div className="p-4 rounded-lg bg-primary-50 border border-primary-100 flex items-start gap-3">
            <i className="ri-shield-check-line text-primary-600 text-lg mt-0.5"></i>
            <p className="text-xs leading-relaxed text-primary-900">
              <span className="font-semibold">安全提示：</span>请通过正规播放器打开文件，注意系统与防病毒软件保持更新。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}